// Empty sim card related
import { createAction } from 'redux-actions'

import {
  ORDER_SUBSCRIPTIONS,
  ORDER_SUBSCRIPTIONS_FINISHED,
} from './constants'

export const orderSubscriptions = createAction(ORDER_SUBSCRIPTIONS, (data) => ({
  ...data,
}))

export const orderSubscriptionsFinished = createAction(ORDER_SUBSCRIPTIONS_FINISHED)
